import React from "react";
import { RestoreOutlined, UnarchiveOutlined } from "@mui/icons-material";
import ConfirmDialog from "./ConfirmDialog";

/**
 * Moves an archived listing back into the live list. Nothing is lost either
 * way, so this one is green and its confirm button says what it does rather
 * than «Так».
 */
const BeforeReturnArchive = ({
  openDialog,
  id,
  returnItem,
  handleCloseDialog,
}) => {
  const confirm = function () {
    handleCloseDialog();
    returnItem(id);
  };

  return (
    <ConfirmDialog
      open={openDialog}
      onClose={handleCloseDialog}
      onConfirm={confirm}
      tone="positive"
      icon={<UnarchiveOutlined />}
      title="Повернути об'єкт у базу?"
      description="Об'єкт повернеться до списку об'єктів і знову з'явиться на сайті."
      confirmLabel="Повернути"
      confirmIcon={<RestoreOutlined />}
    />
  );
};

export default BeforeReturnArchive;
